// extracted by mini-css-extract-plugin
export default {"label":"GaugeLabel_label__WuHdm","base":"GaugeLabel_base__6+jAK"};